export const GrowthPerformance = {
    "sections": [
        {
            "columns": 12,
            "rows": 2,
            "visual": {
                "id": 1,
                "type": "combo",
                "colorTheme": 'colorTheme1',
                "title": "Customer Group Sales with % Growth",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "series": [
                            {
                                "name": 'Actual Sales',
                                "value": 'ActualSales(Value)',
                                "type": 'column'

                            },
                            {
                                "name": 'LY Sales',
                                "value": 'LYSales(Value)',
                                "type": 'column'
                            },
                            {
                                "name": 'Growth %',
                                "value": 'Growth(Value)',
                                "type": 'line'
                            }
                        ],
                        "title": 'CustomerGroup',
                        "endpoint": "N53",
                        "parameters": [
                            { "key": "FromMonth", "value": "2024" },
                            { "key": "FromYear", "value": "1" },
                            { "key": "ToMonth", "value": "2024" },
                            { "key": "ToYear", "value": "1" },
                            { "key": "ConfigTypeCode", "value": "" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {
                                "selectedValueColumn": "CustomerGroup",
                                "selectedTitle": "Channel",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Channel",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Channel',
                                                            "columnName": 'DistributorCode',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LY Sales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'DistributorCode',
                                                    "endpoint": "N53.1",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "CustomerGroup", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "CustomerGroupDistributorCode",
                                                            "selectedTitle": "Customer",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Customer",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'Customer Name',
                                                                                        "columnName": 'CustomerName',
                                                                                        "width": '300px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false
                                                                                    },
                                                                                    {
                                                                                        "name": 'Actual Sales',
                                                                                        "columnName": 'ActualSales(Value)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LY Sales',
                                                                                        "columnName": 'LYSales(Value)',
                                                                                        "width": '135px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Growth %',
                                                                                        "columnName": 'Growth(Value)',
                                                                                        "width": '135px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": 'CustomerName',
                                                                                "endpoint": "N53.2",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "2024" },
                                                                                    { "key": "FromYear", "value": "1" },
                                                                                    { "key": "ToMonth", "value": "2024" },
                                                                                    { "key": "ToYear", "value": "1" },
                                                                                    { "key": "CustomerGroupDistributorCode", "value": "" },
                                                                                    { "key": "ConfigTypeCode", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {
                                                                                        "selectedValueColumn": "CustomerGroupDistributorCodeCustomerCode",
                                                                                        "selectedTitle": "Product",
                                                                                        "visual": [
                                                                                            {
                                                                                                "columns": 12,
                                                                                                "rows": 2,
                                                                                                "visual": {
                                                                                                    "id": 1,
                                                                                                    "type": "advancedTable",
                                                                                                    "colorTheme": "colorTheme1",
                                                                                                    "title": "Product",
                                                                                                    "binding": {
                                                                                                        "data": {
                                                                                                            "columns": [
                                                                                                                {
                                                                                                                    "name": 'Product Name',
                                                                                                                    "columnName": 'ItemName',
                                                                                                                    "width": '400px',
                                                                                                                    "align": "left",
                                                                                                                    "sortable": true,
                                                                                                                    "sum": false
                                                                                                                },
                                                                                                                {
                                                                                                                    "name": 'Actual Sales',
                                                                                                                    "columnName": 'ActualSales(Value)',
                                                                                                                    "width": '140px',
                                                                                                                    "align": "right",
                                                                                                                    "sortable": true,
                                                                                                                    "sum": true
                                                                                                                },
                                                                                                                {
                                                                                                                    "name": 'LY Sales',
                                                                                                                    "columnName": 'LYSales(Value)',
                                                                                                                    "width": '135px',
                                                                                                                    "align": "right",
                                                                                                                    "sortable": true,
                                                                                                                    "sum": true
                                                                                                                },
                                                                                                                {
                                                                                                                    "name": 'Growth %',
                                                                                                                    "columnName": 'Growth(Value)',
                                                                                                                    "width": '135px',
                                                                                                                    "align": "right",
                                                                                                                    "sortable": true,
                                                                                                                    "sum": false,
                                                                                                                    "percent": true
                                                                                                                }
                                                                                                            ],
                                                                                                            "title": 'ItemName',
                                                                                                            "endpoint": "N53.3",
                                                                                                            "parameters": [
                                                                                                                { "key": "FromMonth", "value": "2024" },
                                                                                                                { "key": "FromYear", "value": "1" },
                                                                                                                { "key": "ToMonth", "value": "2024" },
                                                                                                                { "key": "ToYear", "value": "1" },
                                                                                                                { "key": "CustomerGroupDistributorCodeCustomerCode", "value": "" },
                                                                                                                { "key": "ConfigTypeCode", "value": "" }
                                                                                                            ]
                                                                                                        },
                                                                                                        "context": {
                                                                                                            "point": {
                                                                                                                "onClick": {

                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            "columns": 12,
            "rows": 2,
            "visual": {
                "id": 1,
                "type": "advancedTable",
                "colorTheme": "colorTheme1",
                "title": "Sales by Channel Last Year vs Actual Sales",
                "binding": {
                    "data": {
                        "columns": [
                            {
                                "name": 'Channel',
                                "columnName": 'DistributorCode',
                                "width": '140px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                            },
                            {
                                "name": 'Channel Name',
                                "columnName": 'DistributorName',
                                "width": '350px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                            },
                            {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales(Value)',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true
                            },
                            {
                                "name": 'LY Sales',
                                "columnName": 'LYSales(Value)',
                                "width": '130px',
                                "align": "right",
                                "sortable": true,
                                "sum": true
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'Growth(Value)',
                                "width": '130px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            }
                        ],
                        "title": 'DistributorName',
                        "endpoint": "N27",
                        "parameters": [
                            { "key": "FromMonth", "value": "2024" },
                            { "key": "FromYear", "value": "1" },
                            { "key": "ToMonth", "value": "2024" },
                            { "key": "ToYear", "value": "1" },
                            { "key": "DistributorCode", "value": "" },
                            { "key": "ConfigTypeCode", "value": "" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {
                                "selectedValueColumn": "DistributorCode",
                                "selectedTitle": "Customer",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Customer",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Customer Name',
                                                            "columnName": 'CustomerName',
                                                            "width": '300px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LY Sales',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'CustomerName',
                                                    "endpoint": "N27.1",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "DistributorCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "DistributorCustomerCode",
                                                            "selectedTitle": "Product",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Product",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'Product Name',
                                                                                        "columnName": 'ItemName',
                                                                                        "width": '400px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false
                                                                                    },
                                                                                    {
                                                                                        "name": 'Actual Sales',
                                                                                        "columnName": 'ActualSales(Value)',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'LY Sales',
                                                                                        "columnName": 'LYSales(Value)',
                                                                                        "width": '135px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Growth %',
                                                                                        "columnName": 'Growth(Value)',
                                                                                        "width": '135px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": 'ItemName',
                                                                                "endpoint": "N27.2",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "2024" },
                                                                                    { "key": "FromYear", "value": "1" },
                                                                                    { "key": "ToMonth", "value": "2024" },
                                                                                    { "key": "ToYear", "value": "1" },
                                                                                    { "key": "DistributorCustomerCode", "value": "" },
                                                                                    { "key": "ConfigTypeCode", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        }
    ]
}
